import React from 'react'
import { Icon } from 'components'

interface SortableHeaderProps {
    label: string
    sortKey: string
    currentSort: { key: string, direction: 'asc' | 'desc' } | null
    onSort: (key: string) => void
    className?: string
}

export function SortableHeader({ label, sortKey, currentSort, onSort, className = '' }: SortableHeaderProps) {
    const isActive = currentSort?.key === sortKey
    const direction = isActive ? currentSort.direction : 'asc'
    
    return (
        <th 
            onClick={() => onSort(sortKey)} 
            className={`sort-header noselect ${className}`}
            style={{ cursor: 'pointer' }}
        >
            <div className="sort-wrapper">
                <span className="sort-label">{label}</span>
                <div className="sort-buttons">
                    <Icon 
                        noBg 
                        icon={isActive && direction === 'asc' ? 'fas fa-chevron-circle-up' : 'fas fa-chevron-up'} 
                    />
                    <Icon 
                        noBg 
                        icon={isActive && direction === 'desc' ? 'fas fa-chevron-circle-down' : 'fas fa-chevron-down'} 
                    />
                </div>
            </div>
        </th>
    )
}